<script>
	import Dispatch from '../Dispatcher'
	import { faLockAlt, faWallet, faHandHoldingUsd, faPlay, faStop } from '@fortawesome/pro-solid-svg-icons'
	import { faSmile } from '@fortawesome/pro-regular-svg-icons'
	import Fa from 'svelte-fa'
  import { map, tap } from 'rxjs/operators';
  import { withLatestFrom } from 'rxjs/operators';
  import _ from 'lodash'

  export let scaleWidth
  export let percentScale
  export let callback
  export let name

</script>

<div class='flex flex-column items-center'>
  <div class='fw8'>{name}</div>
  <div class='relative mt2' style={'width: '+ scaleWidth + 'px; height:30px;'} on:mousedown={e => callback(  (e.offsetX < 0 ? 1 : e.offsetX)/scaleWidth) } >
    <div class='w-100 br3 bg-gray' style={'height: 10px;'} on:onmousedown={e => {e.preventDefault(); e.stopPropagation()}}></div>
    <div class='absolute bg-moon-gray br3' style={'top: -8px; z-index: 2000; height: 25px; width: 10px; left: ' + percentScale + 'px;'} on:mousedown={e => {e.preventDefault(); e.stopPropagation()}}></div>
  </div>
</div>

<style>
</style>